import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { NavLink } from 'react-router-dom';

export class ChequeShortCutWidget extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            caller: props.Caller,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard/widget/get", { name: 'ChequeShortCutWidget' })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <ul className="row g-gs preview-icon-svg no-drag-widget">
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/out/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#e5e1f5"}}>
                    <span>{this.state.data.outGuaranteeCount} چک</span>
                    <span className="preview-icon-name">ضمانت سررسید شده پرداختی - ما نزد دیگران</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/out/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#f0fff5" }}>
                    <span>{this.state.data.outExpiredCount} چک</span>
                    <span className="preview-icon-name">پرداختی سررسید گذشته</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/out/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#fff0f0" }}>
                    <span>{this.state.data.outRemainCount} چک</span>
                    <span className="preview-icon-name">پرداختی نزدیک سررسید</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/out/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#e5e1f5" }}>
                    <span>{this.state.data.inGuaranteeCount} چک</span>
                    <span className="preview-icon-name">ضمانت سررسید شده دریافتی - دیگران نزد ما </span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/in/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#f0fff5" }}>
                    <span>{this.state.data.inExpiredCount} چک</span>
                    <span className="preview-icon-name">دریافتی سررسید گذشته</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/cheques/in/" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#fff0f0" }}>
                    <span>{this.state.data.inRemainCount} چک</span>
                    <span className="preview-icon-name">دریافتی نزدیک سررسید</span>
                </NavLink>
            </li>
        </ul>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.renderForm()
            ];

        return contents;
    }
}